import { render, staticRenderFns } from "./RegisterCustomer.vue?vue&type=template&id=75359390&scoped=true&lang=pug"
import script from "./RegisterCustomer.vue?vue&type=script&lang=js"
export * from "./RegisterCustomer.vue?vue&type=script&lang=js"
import style0 from "./RegisterCustomer.vue?vue&type=style&index=0&id=75359390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75359390",
  null
  
)

export default component.exports